import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
} from '@mui/material';

import { useChangeNoteStatusMutation } from '../../../../common/apis/AdminApi';
import { ReactComponent as CancelIconBlue } from '../../../../common/assets/icons/cancel_icon_blue.svg';
import { SheetStatus } from '../../../../common/types/SaveSheet';
import { SearchResult } from '../../../../common/types/SearchResult';

type Props = {
  searchResult: SearchResult;
  onClickClose: () => void;
};

const ChangeNoteStatus: React.FC<Props> = ({ onClickClose, searchResult }) => {
  const [value, setValue] = React.useState<SheetStatus>(
    searchResult.status as SheetStatus
  );
  const [changeStatus, { isLoading }] = useChangeNoteStatusMutation();

  const submit = async () => {
    if (isDisabled()) return;

    await changeStatus({
      sheetId: searchResult.sheetId,
      status: value,
    }).unwrap();
    onClickClose();
  };

  const isDisabled = () => searchResult?.status === value;

  if (!searchResult) return <></>;

  return (
    <Box
      sx={{
        maxWidth: '456px',
        minHeight: '274px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flex: 1,
        borderRadius: '15px',
        padding: '40px',
        flexDirection: 'column',
      }}
    >
      <Box className='row' sx={{ alignItems: 'center' }}>
        <IconButton
          onClick={onClickClose}
          sx={{ alignSelf: 'flex-start', justifySelf: 'right' }}
        >
          <CancelIconBlue />
        </IconButton>
        <Typography
          sx={{
            alignSelf: 'center',
            whiteSpace: 'break-spaces',
            textAlign: 'center',
            mb: '24px',
            ml: 'auto',
            mr: 'auto',
          }}
          color='text.primary'
          variant='h5'
        >
          Change Status
        </Typography>
        <Box sx={{ mr: 'auto' }} />
      </Box>
      <Box>
        <Select
          value={value}
          onChange={(e) => setValue(e.target.value as SheetStatus)}
          fullWidth
        >
          <MenuItem value={'Uploaded'} disabled={true}>
            Uploaded
          </MenuItem>
          <MenuItem value={'Processed'} disabled={true}>
            Processed
          </MenuItem>
          <MenuItem value={'Draft'}>Draft</MenuItem>
          <MenuItem value={'Finalized'}>Finalized</MenuItem>
        </Select>
      </Box>
      <Box
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button
          onClick={onClickClose}
          disableElevation
          color='appGray2'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
            marginRight: '15px',
          }}
        >
          <Typography color='white'>Cancel</Typography>
        </Button>
        <LoadingButton
          onClick={submit}
          disabled={isDisabled()}
          loading={isLoading}
          disableElevation
          color='primary'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
          }}
        >
          <Typography color='white'>Ok</Typography>
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default ChangeNoteStatus;
